// category type to base url
export enum CategoryType {
  marketplace = 'marketplacecategories',
  blog = 'blogcategories',
  wiki = 'wikicategories',
  job = 'jobcategories',
}
